enum PageAddDialogFields {
	OPERATION = "operation",
	DOCUMENT = "document",
	PAGE = "page",
	RESET = "reset"
}

export default PageAddDialogFields;